import script from "./minkurv.vue?vue&type=script&setup=true&lang=js"
export * from "./minkurv.vue?vue&type=script&setup=true&lang=js"

import "./minkurv.vue?vue&type=style&index=0&id=0f009808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f009808"]])

export default __exports__